import { render, staticRenderFns } from "./TableEvents.vue?vue&type=template&id=20649d6f&scoped=true&"
import script from "./TableEvents.vue?vue&type=script&lang=js&"
export * from "./TableEvents.vue?vue&type=script&lang=js&"
import style0 from "./TableEvents.vue?vue&type=style&index=0&id=20649d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20649d6f",
  null
  
)

export default component.exports